import React from "react";
import Layout from "../layout/Layout";

const Dashboard = () => {
  return (
    <Layout>
      <>
        <div className="flex justify-center items-center text-lg ">
          <p className="text-5xl mt-52">Coming soon</p>
        </div>
      </>
    </Layout>
  );
};

export default Dashboard;
